import React, { useEffect, useState, useRef } from "react";
import styles from './SimpleTextHL.module.css';
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import PlayButton from "../../components/PlayButton/PlayButton";
import useAudioPlayback from "../../hooks/useAudioPlayback";

const SimpleTextHL = ({ blockData, contentIndex, audioUrl }) => {

  const { state, togglePlayback} = useAudioPlayback(audioUrl, "simple_sentence");
  const scrollableRef = useRef(null);
  const activeItemRef = useRef(null);

  const getHighlighted = (text) => {
    let splitText = text.split(/( )/);
    let textObj = [];
    let word;
    let highLight = false;
    for (let i = 0; i < splitText.length; i++) {
      word = splitText[i];
      if (word.includes("[")) highLight = true;
      textObj.push({ word: highLight ? word.replace("[", "").replace("]", "") : word, highLight: highLight });
      if (word.includes("]")) highLight = false;
    }
    return textObj;
  };

  const searchNextInstruction = () => {
    const index = blockData.content.findIndex((item, i) => i >= contentIndex && item.type === 'instruction');
    return index === -1 ? blockData.content.length : index;
  };

  const searchLastInstruction = () => {
    for (let i = contentIndex; i >= 0; i--) {
      if (blockData.content[i].type === 'instruction') return i;
    }
    return 0;
  };

  
  const handlePlayPause = (contentIndex) => {
    togglePlayback();
  };

  useEffect(() => {
    if (activeItemRef.current && scrollableRef.current) {
      const activeElement = activeItemRef.current;
      const container = scrollableRef.current;
      
      const containerHeight = container.clientHeight;
      const elementTop = activeElement.offsetTop;
      const elementHeight = activeElement.clientHeight;
      
      const scrollTop = elementTop - (containerHeight / 2) + (elementHeight / 2);
      
      container.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }
  }, [contentIndex]);

  return (
    <div>
      <div>
        {blockData.content[contentIndex].type === 'instruction' ? (
          <LessonInstruction
            instructionText={blockData.content[contentIndex].instruction}
            audioUrl={audioUrl}
          />
        ) : (
          <div className="bg-white">
            <div className={styles.simple_highlight_txt_bar}>
              <PlayButton className={styles.audio_icon_container} isPlaying={state === 'playing'} onClick={handlePlayPause} size="1x"/>
              <h2 className={styles.simple_highlight_txt_header}>{blockData.content[0].section}</h2>
            </div>
            <div className={styles.scrollable_content} ref={scrollableRef}>
              {blockData.content.slice(searchLastInstruction() + 1, searchNextInstruction()).map((item, actualIndex) => {
                const index = searchLastInstruction() + 1 + actualIndex;
                const isVisited = index < contentIndex;
                const isActive = index === contentIndex;
                return (
                  <div
                    key={index}
                    ref={isActive ? activeItemRef : null}
                    className={`${styles.simple_highlight_container} 
                                ${isActive ? styles.simple_active : ""} 
                                ${isVisited ? styles.simple_visited : ""}`}>
                    {getHighlighted(item.en).map((word, wordIndex) => (
                      <span key={wordIndex} style={{ color: word.highLight ? 'rgb(47, 157, 201)' : "black" }}>
                        {word.word}
                      </span>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
 
export default SimpleTextHL;
